// GENERATED by art-masters/v10/deities/live/scripts/gen_hall_manifest.py - do not edit.
// Pre-keyed transparent idle loops for the hall figures (key_hall_clips.py). Each clip starts and ends on the
// same base frame (PixVerse start = end frame), so it loops and clips can follow each other in any order.
/* eslint-disable @typescript-eslint/no-require-imports */
export interface HallClipSet {
  aspect: number;
  poster: number;
  webm: number[]; // VP9 + alpha (Chrome, Firefox, Android)
  mov: number[]; // HEVC + alpha (Safari, iOS)
}
export const HALL_CLIPS: Record<string, HallClipSet> = {
  aidos: {
    aspect: 202 / 480,
    poster: require('../../assets/v10/deities/live/aidos/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/aidos/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/aidos/hall_0.mov')],
  },
  argos: {
    aspect: 248 / 480,
    poster: require('../../assets/v10/deities/live/argos/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/argos/hall_0.webm'), require('../../assets/v10/deities/live/argos/hall_1.webm')],
    mov: [require('../../assets/v10/deities/live/argos/hall_0.mov'), require('../../assets/v10/deities/live/argos/hall_1.mov')],
  },
  astra: {
    aspect: 172 / 480,
    poster: require('../../assets/v10/deities/live/astra/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/astra/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/astra/hall_0.mov')],
  },
  bia: {
    aspect: 274 / 480,
    poster: require('../../assets/v10/deities/live/bia/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/bia/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/bia/hall_0.mov')],
  },
  clio: {
    aspect: 204 / 480,
    poster: require('../../assets/v10/deities/live/clio/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/clio/hall_0.webm'), require('../../assets/v10/deities/live/clio/hall_1.webm'), require('../../assets/v10/deities/live/clio/hall_2.webm'), require('../../assets/v10/deities/live/clio/hall_3.webm')],
    mov: [require('../../assets/v10/deities/live/clio/hall_0.mov'), require('../../assets/v10/deities/live/clio/hall_1.mov'), require('../../assets/v10/deities/live/clio/hall_2.mov'), require('../../assets/v10/deities/live/clio/hall_3.mov')],
  },
  elis: {
    aspect: 156 / 480,
    poster: require('../../assets/v10/deities/live/elis/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/elis/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/elis/hall_0.mov')],
  },
  filot: {
    aspect: 218 / 480,
    poster: require('../../assets/v10/deities/live/filot/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/filot/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/filot/hall_0.mov')],
  },
  frosy: {
    aspect: 306 / 480,
    poster: require('../../assets/v10/deities/live/frosy/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/frosy/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/frosy/hall_0.mov')],
  },
  horkos: {
    aspect: 200 / 480,
    poster: require('../../assets/v10/deities/live/horkos/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/horkos/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/horkos/hall_0.mov')],
  },
  hrmez: {
    aspect: 314 / 480,
    poster: require('../../assets/v10/deities/live/hrmez/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/hrmez/hall_0.webm'), require('../../assets/v10/deities/live/hrmez/hall_1.webm')],
    mov: [require('../../assets/v10/deities/live/hrmez/hall_0.mov'), require('../../assets/v10/deities/live/hrmez/hall_1.mov')],
  },
  hyga: {
    aspect: 266 / 480,
    poster: require('../../assets/v10/deities/live/hyga/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/hyga/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/hyga/hall_0.mov')],
  },
  hypnos: {
    aspect: 200 / 480,
    poster: require('../../assets/v10/deities/live/hypnos/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/hypnos/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/hypnos/hall_0.mov')],
  },
  irene: {
    aspect: 250 / 480,
    poster: require('../../assets/v10/deities/live/irene/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/irene/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/irene/hall_0.mov')],
  },
  janus: {
    aspect: 204 / 480,
    poster: require('../../assets/v10/deities/live/janus/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/janus/hall_0.webm'), require('../../assets/v10/deities/live/janus/hall_1.webm')],
    mov: [require('../../assets/v10/deities/live/janus/hall_0.mov'), require('../../assets/v10/deities/live/janus/hall_1.mov')],
  },
  kerdos: {
    aspect: 216 / 480,
    poster: require('../../assets/v10/deities/live/kerdos/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/kerdos/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/kerdos/hall_0.mov')],
  },
  keso: {
    aspect: 208 / 480,
    poster: require('../../assets/v10/deities/live/keso/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/keso/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/keso/hall_0.mov')],
  },
  krnos: {
    aspect: 220 / 480,
    poster: require('../../assets/v10/deities/live/krnos/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/krnos/hall_0.webm'), require('../../assets/v10/deities/live/krnos/hall_1.webm')],
    mov: [require('../../assets/v10/deities/live/krnos/hall_0.mov'), require('../../assets/v10/deities/live/krnos/hall_1.mov')],
  },
  kyrs: {
    aspect: 326 / 480,
    poster: require('../../assets/v10/deities/live/kyrs/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/kyrs/hall_0.webm'), require('../../assets/v10/deities/live/kyrs/hall_1.webm'), require('../../assets/v10/deities/live/kyrs/hall_2.webm')],
    mov: [require('../../assets/v10/deities/live/kyrs/hall_0.mov'), require('../../assets/v10/deities/live/kyrs/hall_1.mov'), require('../../assets/v10/deities/live/kyrs/hall_2.mov')],
  },
  meta: {
    aspect: 190 / 480,
    poster: require('../../assets/v10/deities/live/meta/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/meta/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/meta/hall_0.mov')],
  },
  metis: {
    aspect: 258 / 480,
    poster: require('../../assets/v10/deities/live/metis/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/metis/hall_0.webm'), require('../../assets/v10/deities/live/metis/hall_1.webm')],
    mov: [require('../../assets/v10/deities/live/metis/hall_0.mov'), require('../../assets/v10/deities/live/metis/hall_1.mov')],
  },
  monoi: {
    aspect: 166 / 480,
    poster: require('../../assets/v10/deities/live/monoi/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/monoi/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/monoi/hall_0.mov')],
  },
  moyri: {
    aspect: 394 / 480,
    poster: require('../../assets/v10/deities/live/moyri/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/moyri/hall_0.webm'), require('../../assets/v10/deities/live/moyri/hall_1.webm')],
    mov: [require('../../assets/v10/deities/live/moyri/hall_0.mov'), require('../../assets/v10/deities/live/moyri/hall_1.mov')],
  },
  nemos: {
    aspect: 236 / 480,
    poster: require('../../assets/v10/deities/live/nemos/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/nemos/hall_0.webm'), require('../../assets/v10/deities/live/nemos/hall_1.webm')],
    mov: [require('../../assets/v10/deities/live/nemos/hall_0.mov'), require('../../assets/v10/deities/live/nemos/hall_1.mov')],
  },
  numa: {
    aspect: 216 / 480,
    poster: require('../../assets/v10/deities/live/numa/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/numa/hall_0.webm'), require('../../assets/v10/deities/live/numa/hall_1.webm'), require('../../assets/v10/deities/live/numa/hall_2.webm'), require('../../assets/v10/deities/live/numa/hall_3.webm')],
    mov: [require('../../assets/v10/deities/live/numa/hall_0.mov'), require('../../assets/v10/deities/live/numa/hall_1.mov'), require('../../assets/v10/deities/live/numa/hall_2.mov'), require('../../assets/v10/deities/live/numa/hall_3.mov')],
  },
  oracle: {
    aspect: 168 / 480,
    poster: require('../../assets/v10/deities/live/oracle/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/oracle/hall_0.webm'), require('../../assets/v10/deities/live/oracle/hall_1.webm'), require('../../assets/v10/deities/live/oracle/hall_2.webm')],
    mov: [require('../../assets/v10/deities/live/oracle/hall_0.mov'), require('../../assets/v10/deities/live/oracle/hall_1.mov'), require('../../assets/v10/deities/live/oracle/hall_2.mov')],
  },
  pistis: {
    aspect: 260 / 480,
    poster: require('../../assets/v10/deities/live/pistis/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/pistis/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/pistis/hall_0.mov')],
  },
  pitho: {
    aspect: 228 / 480,
    poster: require('../../assets/v10/deities/live/pitho/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/pitho/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/pitho/hall_0.mov')],
  },
  plutus: {
    aspect: 200 / 480,
    poster: require('../../assets/v10/deities/live/plutus/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/plutus/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/plutus/hall_0.mov')],
  },
  praxi: {
    aspect: 190 / 480,
    poster: require('../../assets/v10/deities/live/praxi/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/praxi/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/praxi/hall_0.mov')],
  },
  prono: {
    aspect: 212 / 480,
    poster: require('../../assets/v10/deities/live/prono/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/prono/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/prono/hall_0.mov')],
  },
  pyda: {
    aspect: 224 / 480,
    poster: require('../../assets/v10/deities/live/pyda/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/pyda/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/pyda/hall_0.mov')],
  },
  syka: {
    aspect: 262 / 480,
    poster: require('../../assets/v10/deities/live/syka/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/syka/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/syka/hall_0.mov')],
  },
  telos: {
    aspect: 326 / 480,
    poster: require('../../assets/v10/deities/live/telos/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/telos/hall_0.webm'), require('../../assets/v10/deities/live/telos/hall_1.webm'), require('../../assets/v10/deities/live/telos/hall_2.webm')],
    mov: [require('../../assets/v10/deities/live/telos/hall_0.mov'), require('../../assets/v10/deities/live/telos/hall_1.mov'), require('../../assets/v10/deities/live/telos/hall_2.mov')],
  },
  themis: {
    aspect: 182 / 480,
    poster: require('../../assets/v10/deities/live/themis/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/themis/hall_0.webm'), require('../../assets/v10/deities/live/themis/hall_1.webm')],
    mov: [require('../../assets/v10/deities/live/themis/hall_0.mov'), require('../../assets/v10/deities/live/themis/hall_1.mov')],
  },
  tkne: {
    aspect: 208 / 480,
    poster: require('../../assets/v10/deities/live/tkne/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/tkne/hall_0.webm'), require('../../assets/v10/deities/live/tkne/hall_1.webm')],
    mov: [require('../../assets/v10/deities/live/tkne/hall_0.mov'), require('../../assets/v10/deities/live/tkne/hall_1.mov')],
  },
  urax: {
    aspect: 382 / 480,
    poster: require('../../assets/v10/deities/live/urax/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/urax/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/urax/hall_0.mov')],
  },
  uthen: {
    aspect: 190 / 480,
    poster: require('../../assets/v10/deities/live/uthen/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/uthen/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/uthen/hall_0.mov')],
  },
  xaris: {
    aspect: 160 / 480,
    poster: require('../../assets/v10/deities/live/xaris/hall_poster.png'),
    webm: [require('../../assets/v10/deities/live/xaris/hall_0.webm')],
    mov: [require('../../assets/v10/deities/live/xaris/hall_0.mov')],
  },
};
